// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpdatesHeader/UpdatesHeader.css
// module id = 954
// module chunks = 0